import { CurrencyInput, type CurrencyInputProps } from '@eika/currency-input';
import { useInputs } from '@hooks/use-inputs';
import './numeric-input.scss';
import { useDataAttributes } from '@data-attributes/use-data-attributes';
import useTranslation from '@translation-utils/use-translation';

export const InitialInvestmentInput = () => {
    const { inputs } = useTranslation();
    const { inputFieldDataAttrs } = useDataAttributes();

    return (
        <CalcNumericInput
            name="initialInvestment"
            inputfieldkey="initialInvestment"
            label={inputs.initialInvestment}
            {...inputFieldDataAttrs.initialInvestment}
        />
    );
};

export const MonthlyContributionInput = () => {
    const { inputs } = useTranslation();
    const { inputFieldDataAttrs } = useDataAttributes();

    return (
        <CalcNumericInput
            name="monthlyContribution"
            inputfieldkey="monthlyContribution"
            label={inputs.monthlyContribution}
            {...inputFieldDataAttrs.monthlyContribution}
        />
    );
};

export const SavingPeriodYearsInput = () => {
    const { inputs } = useTranslation();
    const { inputFieldDataAttrs } = useDataAttributes();

    return (
        <CalcNumericInput
            name="savingPeriodYears"
            inputfieldkey="savingPeriodYears"
            label={inputs.savingPeriodYears}
            suffix="år"
            maxLength={5} // 2 digits + " år"
            {...inputFieldDataAttrs.savingPeriodYears}
        />
    );
};

interface CalcNumericInputProps extends CurrencyInputProps {
    inputfieldkey: 'initialInvestment' | 'monthlyContribution' | 'savingPeriodYears';
}

const CalcNumericInput = (props: CalcNumericInputProps) => {
    const { calcInputs, setCalcInputs } = useInputs();
    const { inputfieldkey } = props;

    return (
        <div className="numeric-input-row">
            <CurrencyInput
                {...props}
                className="numeric-input"
                value={calcInputs[inputfieldkey]}
                onValueChange={({ floatValue }) => {
                    setCalcInputs({
                        ...calcInputs,
                        [inputfieldkey]: floatValue,
                    });
                }}
                autoComplete="off"
            />
        </div>
    );
};
